import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { Wrapper } from "./style/style";
import API from "../../api/axios";
import { APP_URLS } from "../../api/url";
import { APIError, removeUnderscoreAndCapitalize } from "../../core/utils";
import NoRecord from "../../assets/SharedComponents/Table/NoRecord";
import Pagination from "../../assets/SharedComponents/Pagination";
import StaticFilter from "../../assets/SharedComponents/Filters/StaticFilter";
import { ASSISTANCE_REQUEST_STATUS } from "../../config/constant";
import { Tooltip } from "@mui/material";
import { FaFilterIcon } from "../../assets/Images/icon";
import CountryFilter from "../../assets/SharedComponents/Filters/CountryFilter";
import Status from "./Components/Status";
import { Link } from "react-router-dom";
import moment from "moment";
import RecordCount from "../../assets/SharedComponents/RecordCount/RecordCount";

const AssistanceStatuses = [
  { name: "All", value: null },
  ...Object.keys(ASSISTANCE_REQUEST_STATUS).map((key) => ({
    name: removeUnderscoreAndCapitalize(key.toLowerCase()),
    value: ASSISTANCE_REQUEST_STATUS[key],
  }))
];

const NeedAssistance = () => {
  const [assistanceRequests, _assistanceRequests] = useState([]);
  const [pagintation, _pagintation] = useState({
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
    RecordsPerPage: 10,
  });

  const [filters, _filters] = useState({
    status: "",
    country_id: "",
    requested_from: "",
    requested_to: "",
  });

  const [loader, _loader] = useState(false);
  const [refetchApi, _refetchApi] = useState()

  useEffect(() => {
    getAssistanceRequests();
  }, [pagintation.currentPage, pagintation.RecordsPerPage, filters, refetchApi]);

  const getAssistanceRequests = () => {
    _loader(true);

    const params = new URLSearchParams({
      page: pagintation.currentPage,
      per_page: pagintation.RecordsPerPage,
    });

    if (filters.status) params.append("filter[status]", filters.status);
    if (filters.country_id) params.append("filter[country_id]", filters.country_id);
    if (filters.requested_from) params.append("filter[requested_from]", filters.requested_from);
    if (filters.requested_to) params.append("filter[requested_to]", filters.requested_to);

    API.get(`${APP_URLS.LIST_ASSISTANCE_REQUESTS}?${params.toString()}`)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _assistanceRequests(resp.data.data);
          _pagintation((prev) => ({
            ...prev,
            totalPages: resp.data.last_page,
            totalRecords: resp.data.total,
          }));
        } else {
          toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch((error) => {
        let error_message = APIError(error);
        toast.error(error_message, { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => {
        _loader(false);
      });
  };

  const handleFilterChange = (key, value) => {
    _filters((prev) => ({ ...prev, [key]: value }));
    _pagintation((prev) => ({ ...prev, currentPage: 1, totalPages: 0 }));
  };

  const clearFilter = () => {
    _filters({
      status: "",
      country_id: "",
      requested_from: "",
      requested_to: "",
    });
    _pagintation((prev) => ({ ...prev, currentPage: 1, totalPages: 0, RecordsPerPage: 10 }));
  };

  return (
    <Wrapper>
      <div className="auctionMainContainer">
        <div className="row mt-4">
          <div className="col-md-12 text-align-center">
            <h1>Assistance Requests</h1>
          </div>
        </div>

        {/* Filters */}
        <div className="d-flex align-items-center justify-content-end info-wrap mt-3 mb-2 gap-2">
          <input
            type={filters.requested_from ? "date" : "text"}
            placeholder="Start Date"
            value={filters.requested_from}
            max={filters.requested_to || new Date().toISOString().split("T")[0]}
            onFocus={(e) => (e.target.type = "date")}
            onBlur={(e) => !filters.requested_from && (e.target.type = "text")}
            onChange={(e) => handleFilterChange("requested_from", e.target.value)}
            className="datefilter"
          />
          <input
            type={filters.requested_to ? "date" : "text"}
            placeholder="End Date"
            value={filters.requested_to}
            min={filters.requested_from}
            max={new Date().toISOString().split("T")[0]}
            onFocus={(e) => (e.target.type = "date")}
            onBlur={(e) => !filters.requested_to && (e.target.type = "text")}
            onChange={(e) => handleFilterChange("requested_to", e.target.value)}
            className="datefilter"
          />

          <CountryFilter
            value={filters.country_id}
            handleChange={(value) => handleFilterChange("country_id", value)}
          />

          <StaticFilter
            data={AssistanceStatuses}
            handleChange={(e) => handleFilterChange("status", e.target.value)}
            value={filters.status}
          />

          <RecordCount
            onSearchClick={(search) => _pagintation((prev) => ({ ...prev, RecordsPerPage: search }))}
            val={pagintation.RecordsPerPage}
            key={pagintation.RecordsPerPage}
          />

          <Tooltip title="Clear Filter" placement="bottom">
            <FaFilterIcon className="filter-icon" role="button" onClick={clearFilter} />
          </Tooltip>
        </div>

        {/* Info */}
        <div className="d-flex align-items-center justify-content-between info-wrap mt-3 mb-2">
          <div className="justify-content-end mt-1 me-2">
            <span className="text-start">
              Total Records : <b>{pagintation.totalRecords}</b>
            </span>
          </div>
        </div>

        {/* Table */}
        <div className="tableContainer">
          <table className="auctionTable">
            <thead className="tableHead">
              <tr className="table-row">
                <th>ID</th>
                <th>Name</th>
                <th>Subsidiary Name
                  <br />
                  City, Zip
                </th>
                <th>Country</th>
                <th>Phone Number</th>
                <th>Status</th>
                <th>Action By</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th>Reason</th>
              </tr>
            </thead>
            {loader ? (
              <div className="d-flex justify-content-center three-dot">
                <ThreeDots height="150" width="150" radius="9" color="#637df4" ariaLabel="three-dots-loading" visible={true} />
              </div>
            ) : (
              <tbody>
                {assistanceRequests.length > 0 ? (
                  assistanceRequests.map((req) => (
                    <tr key={req.id} className="table-row">
                      <td>
                        {req.id}
                      </td>
                      <td>
                        <Link to={`/detail-member/${req.user.id}`} className="navigationLink">
                          {req?.user?.first_name || ""} {req?.user?.last_name || ""}
                        </Link>
                      </td>
                      <td>
                        {req?.subsidiary?.id ?
                          <>
                            <Link to={`/company-details/${req.subsidiary.id}`} className="navigationLink">
                              {req.subsidiary?.name || "-"}
                            </Link>
                            <br />
                            {req.subsidiary?.limited_address?.locality}, {req.subsidiary?.limited_address?.postal_code}
                          </>
                          : "-"
                        }
                      </td>
                      <td>
                        {req?.country?.flag_thumbnail ? (
                          <img src={req.country.flag_thumbnail} alt="" className="countryflag" />
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{`${req?.country?.prefix_call ? `${req.country.prefix_call} ` : ""}${req.phone_number}`}</td>
                      <td>
                        <Status currentStatus={req.status} requestId={req.id} _refetchApi={_refetchApi} />
                      </td>
                      <td>{req.action_by_name || "-"}</td>
                      <td>
                        {
                          moment(new Date(req.created_at))
                            .tz("Europe/Amsterdam")
                            .format("DD-MM-YYYY HH:mm")
                        }
                      </td>
                      <td>
                        {
                          moment(new Date(req.updated_at))
                            .tz("Europe/Amsterdam")
                            .format("DD-MM-YYYY HH:mm")
                        }
                      </td>
                      <td>{req.reason || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <NoRecord />
                )}
              </tbody>
            )}
          </table>
        </div>

        {/* Pagination */}
        {pagintation.totalPages > 1 && (
          <Pagination
            totalPages={pagintation.totalPages}
            page={pagintation.currentPage}
            key={pagintation.totalPages}
            onPageClick={(page) => _pagintation((prev) => ({ ...prev, currentPage: page + 1 }))}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default NeedAssistance;
